import { render } from "./ConsentItem.vue?vue&type=template&id=16c29efc&scoped=true&ts=true"
import script from "./ConsentItem.vue?vue&type=script&lang=ts"
export * from "./ConsentItem.vue?vue&type=script&lang=ts"

import "./ConsentItem.vue?vue&type=style&index=0&id=16c29efc&scoped=true&lang=scss"

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c29efc"]])

export default __exports__